import { apiFetch as fetch } from "apiClient";
import { validateAdvancedOrderConfig } from "./validators/index";
import { buildApiPayload } from "./builders/buildPayloadBase";

export async function submitAdvancedOrder(config, ctx) {
    const { instrument, segment, depthInstrumentToken, existingOrder } = ctx;

    if (!instrument?.tradingsymbol) return { success: false, message: "Missing tradingsymbol" };
    if (!segment) return { success: false, message: "Missing exchange segment" };

    const validation = validateAdvancedOrderConfig(config);
    if (validation) return { success: false, message: validation };

    // KEEP_RISE uses different controller endpoints in your system
    if (config.mode === "KEEP_RISE") {
        const url = existingOrder
            ? `/api/kite-orders/keep-rise/${existingOrder.id}/edit`
            : `/api/kite-orders/keep-rise/create`;

        const payload = buildApiPayload(config, { instrument, segment, depthInstrumentToken });
        const resp = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
        if (!resp.ok) return fail(resp);
        return wrap(await resp.json());
    }

    // CONSISTENT / RANGE / PREOPEN go to /api/advanced-orders
    const url = existingOrder
        ? `/api/advanced-orders/${existingOrder.id}/edit`
        : `/api/advanced-orders/create`;

    const payload = buildApiPayload(config, { instrument, segment, depthInstrumentToken });

    const resp = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
    if (!resp.ok) return fail(resp);
    return wrap(await resp.json());
}

async function fail(resp) {
    const text = await resp.text();
    return { success: false, message: text || `HTTP ${resp.status}` };
}

function wrap(json) {
    if (json?.success) return { success: true, message: json.message || "Success" };
    return { success: false, message: json?.message || "Failed" };
}
